import { render, staticRenderFns } from "./DeleteUndoToast.vue?vue&type=template&id=3fb1fc1b"
import script from "./DeleteUndoToast.vue?vue&type=script&lang=js"
export * from "./DeleteUndoToast.vue?vue&type=script&lang=js"
import style0 from "./DeleteUndoToast.vue?vue&type=style&index=0&id=3fb1fc1b&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports